<template>
    <div>
        <RecomPullNew v-if="recommendedActivity.length" :recommendedActivity="recommendedActivity"/>
        <RecomCoupon
          v-if="couponInfoList.length"
          :couponInfoList="couponInfoList"
          @resetInfo="resetInfo"
        />
        <RecomCourse v-if="recommendVOProduct.length" :recommendVOProduct="recommendVOProduct"/>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { getRecommentInfoApi } from '@/api/pullNew';
import RecomPullNew from './recomPullNew.vue';
import RecomCourse from './recomProducts.vue';
import RecomCoupon from './recomCoupons.vue';

export default {
  props: {
    activityId: {
      type: String,
    },
  },
  data() {
    return {
      recommendedActivity: [],
      couponInfoList: [],
      recommendVOProduct: [],
    };
  },
  components: {
    RecomPullNew,
    RecomCourse,
    RecomCoupon,
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    userInfo: {
      async handler(newVal) {
        if (newVal.id && this.$root.$data.isApp) { // 解决在APP内登录后 优惠券状态的问题
          this.getInfo();
        }
      },
      deep: true,
    },
  },

  methods: {
    resetInfo() {
      this.getInfo();
    },
    async getInfo() {
      const { code, data } = await getRecommentInfoApi(this.activityId);
      if (code === 0) {
        const { recommendedActivity, couponInfoList, recommendVOProduct } = data;
        this.recommendedActivity = recommendedActivity ?? [];
        this.couponInfoList = couponInfoList ?? [];
        this.recommendVOProduct = recommendVOProduct ?? [];
      }
    },
  },
  created() {
    this.getInfo();
  },
};
</script>
